export const cellsMessages = {
	MSG_FILE_EXPIRED: {
		title: 'Arquivo expirado',
		description:
			'O arquivo foi automaticamente excluído após 7 dias. Exporte novamente o plano.',
		status: 'warning',
	},
	MSG_FILE_NOT_AVAILABLE: {
		title: 'Arquivo não disponível',
		description: 'O arquivo não está disponível para download.',
		status: 'warning',
	},
	MSG_ERROR_DOWNLOAD: {
		title: 'Erro ao fazer download',
		description: 'Tente novamente em alguns instantes.',
		status: 'error',
	},
	MSG_DOWNLOAD_STARTING: {
		title: 'Download iniciado',
		description:
			'O download do arquivo está sendo iniciado. Por favor, aguarde...',
		status: 'info',
	},

	LABELS: {
		DOWNLOAD_FILE: 'Baixar arquivo',
		FILE_EXPIRED: 'Arquivo expirado',
		NO_DATA: '-',
	},

	TOOLTIPS: {
		FILE_EXPIRED:
			'O arquivo não está mais disponível. Exporte novamente o plano restrito.',
		FILE_EXPIRES_DAYS: (days: number) =>
			`Link do arquivo expira em ${days} ${days === 1 ? 'dia' : 'dias'}`,
		FILE_EXPIRED_LINK: 'Link do arquivo expirado',
		DOWNLOAD_DISABLED:
			'O download já foi iniciado. Feche e abra novamente a modal de Atividades Recentes para baixar o arquivo novamente.',
	},
} as const;

export type CellsMessageType =
	(typeof cellsMessages)[keyof typeof cellsMessages];
